import { useMutation } from '@tanstack/react-query'
import { api } from '@api'

interface SummarizeParams {
  conversationId: string
}

interface SummarizeResponse {
  summary: string
}

const summarizeConversation = async (params: SummarizeParams): Promise<SummarizeResponse> => {
  const { data } = await api.post<SummarizeResponse>('/ft_conversation-ai/summarize', params)
  return data
}

export const useFtConversationAiSummarize = () => {
  return useMutation<SummarizeResponse, Error, SummarizeParams>({
    mutationFn: summarizeConversation,
  })
}
